import { EuiButton, EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchOrderingModes } from '../../api/outlet/fetchOrderingModes';
import { userHasPermission } from '../../helper/auth';
import AddSection from './AddSection';
import AddTable from './AddTable';
import { fetchOutletSections } from './Api/fetchOutletSections';
import Sections from './Sections';

const TableManagementScreen = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const outletId = useSelector((state) => state.outlet.selectedOutletId);
    const [isEditTableMode, setIsEditTableMode] = useState(false);
    const sections = useSelector((state) => state.tableManagement.sectionList);
    const permissions = useSelector((state) => state.permission.permission);

    const handleEditTables = useCallback(() => {
        setIsEditTableMode((prevState) => !prevState);
    }, []);

    useEffect(() => {
        dispatch(fetchOutletSections());
        dispatch(fetchOrderingModes());
    }, [dispatch, outletId]);

    useEffect(() => {
        if (!sections?.length) {
            setIsEditTableMode(false);
        }
    }, [sections]);

    return (
        <>
            <EuiFlexGroup direction='row' justifyContent='flexEnd' gutterSize='s'>
                <EuiFlexItem grow={false}>
                    <AddTable isEditTableMode={isEditTableMode} />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <AddSection isEditTableMode={isEditTableMode} />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <EuiButton
                        fill={!isEditTableMode}
                        disabled={
                            !sections?.length || !userHasPermission(permissions, history.location.pathname, 'write')
                        }
                        onClick={handleEditTables}
                    >
                        {!isEditTableMode ? 'Edit Modes' : 'Cancel Edit'}
                    </EuiButton>
                </EuiFlexItem>
            </EuiFlexGroup>

            <Sections isEditTableMode={isEditTableMode} />
        </>
    );
};

export default React.memo(TableManagementScreen);
